import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export const store = new Vuex.Store({
    //strict: process.env.NODE_ENV !== 'production',

    state: {
        project: {
            interdisciplinar: false,
            colaboradores: [],
            bolsas: [
                {
                    plano_trabalho: "",
                    projeto_id: 0
                }
            ],
            avaliacao: {
                avaliacao_projeto: null,
                avaliacao_curriculo: null,
                avaliacao_artistico_cultural: null,
                avaliacao_siac: null,
                avaliacao_relatorio: {
                    voluntarios : [],
                    bolsistas: []
                }
            },
            curriculo: {
                lattes: "",
                atuacoes: [
                    {
                        id: 0,
                        atuacao: {
                            id: 0,
                            tipo: "",
                            nome: ""
                        }
                    }
                ],
                usuario: {
                    id: 0,
                    unidade: {
                        id: 0,
                        centro: {
                            id: 0
                        }
                    }
                }
            }
        }
    },

    mutations: {
        setProject(state, newProject) {
            state.project = newProject;
        },

        setAvaliacao(state, payload) {
            state.project.avaliacao = payload;
        },
        setAvaliacaoProjeto(state, payload) {
            state.project.avaliacao.avaliacao_projeto = payload;
        },
        setAvaliacaoCurriculo(state, payload) {
            state.project.avaliacao.avaliacao_curriculo = payload;
        },
        setBolsas(state, payload) {
            state.project.bolsas = payload;
        },
        setAvaliacaoCurriculoItemFormacao(state, payload) {
            state.project.avaliacao.avaliacao_curriculo.item_formacao = payload;
        },
        setAvaliacaoCurriculoItemProducao(state, payload) {
            state.project.avaliacao.avaliacao_curriculo.item_producao = payload;
        },
        setAvaliacaoArtisticoCultural(state, payload) {
            state.project.avaliacao.avaliacao_artistico_cultural = payload;
        },

        setAvaliacaoArtisticoSiac(state, payload) {
            state.project.avaliacao.avaliacao_siac = payload;
        },
        setAvaliacaoRelatorioVoluntarios(state, payload) {
            state.project.avaliacao.avaliacao_relatorio.voluntarios = payload;
        },
        setAvaliacaoRelatorioBolsistas(state, payload) {
            state.project.avaliacao.avaliacao_relatorio.bolsistas = payload;
        }
    },
    actions: {
        setProject(context, payload) {
            context.commit("setProject", payload);
        },
        setAvaliacao({ commit, state }, payload) {
            let { projeto: project } = payload;
            project.avaliacao = payload;
            project.avaliacao.projeto ? delete project.avaliacao.projeto : null;
            commit("setAvaliacao", project.avaliacao);
        },
        setAvaliacaoProjeto({ commit }, payload) {
            commit("setAvaliacaoProjeto", payload);
        },
        setAvaliacaoCurriculo({ commit }, payload) {
            commit("setAvaliacaoCurriculo", payload);
        },
        setAvaliacaoCurriculoItemFormacao({ commit }, payload) {
            commit("setAvaliacaoCurriculoItemFormacao", payload);
        },
        setAvaliacaoCurriculoItemProducao({ commit }, payload) {
            commit("setAvaliacaoCurriculoItemProducao", payload);
        },
        setBolsas({ commit }, payload) {
            commit("setBolsas", payload);
        },
        setAvaliacaoArtisticoCultural({ commit }, payload) {
            commit("setAvaliacaoArtisticoCultural", payload);
        },
        setAvaliacaoSiac({ commit }, payload) {
            commit("setAvaliacaoSiac", payload);
        },
        setAvaliacaoRelatorioBolsistas({ commit }, payload) {
            commit("setAvaliacaoRelatorioBolsistas", payload);
        },
        setAvaliacaoRelatorioVoluntarios({ commit }, payload) {
            commit("setAvaliacaoRelatorioVoluntarios", payload);
        }
    },
    getters: {
        atuacoesUsuario: state => tipo =>
            state.project.curriculo.atuacoes.filter(atuacao => {
                return atuacao.atuacao.tipo == tipo;
            }),
        getItemFormacao: state => id => {
            if (
                state.project.avaliacao.avaliacao_curriculo &&
                state.project.avaliacao.avaliacao_curriculo.item_formacao
            )
                return state.project.avaliacao.avaliacao_curriculo.item_formacao.find(
                    e => e.id == id
                );
            else return { valor: 0 };
        }
    }
});
